import styled from 'styled-components';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: ${WindowBreakpoints.medium}px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Logo = styled.img`
  height: 30px;

  @media (max-width: ${WindowBreakpoints.small}px) {
    max-width: 125px;
    max-height: 30px;
    height: auto;
    width: auto;
  }
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TitleData = styled.span`
  color: ${({ theme: { colors } }) => colors['black']};
  font-size: ${({ theme: { fontSize } }) => fontSize.sm};
`;
